import { useEffect } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa";
import AppLayout from "./layout/Applayout";
import HomePage from "./pages/Home/Home";
import AboutPage from "./pages/About/About";
import SpeakerPage from "./pages/Speakers/Speaker";
import TeamPage from "./pages/Team/Team";
import SponsorPage from "./pages/Sponsors/Sponsor";
import EventPage from "./pages/Event/Event";
import BlogPage from "./pages/Blogs/Blogs";
import BlogPost from "./pages/Blogs/BlogPost";
import ErrorPage from "./pages/Error/Error";
import Ticket from "./pages/Ticket/Ticket";
import Aos from "aos";
import "aos/dist/aos.css";
import { useGlobalContext } from "./contexts/context";
import Loading from "./components/Loading/Loading";
import CloseTicket from "./components/closeTicket/CloseTicket";

// TODO: I MIGHT NEED TO CHANGE THE SANITY TO CONTENTFUL CMS

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "speakers",
        element: <SpeakerPage />,
      },
      {
        path: "organizers",
        element: <TeamPage />,
      },
      {
        path: "sponsors",
        element: <SponsorPage />,
      },
      {
        path: "event",
        element: <EventPage />,
      },
      {
        path: "blog",
        element: <BlogPage />,
      },
      {
        path: "blog/:slug",
        element: <BlogPost />,
      },
      {
        path: "/ticket",
        element: <Ticket />,
      },
    ],
  },
]);

function App() {
  const { isLoading } = useGlobalContext();

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
      offset: 200,
      easing: "ease-in-out",
    });
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="App">
      <RouterProvider router={router} />
      {/* eslint-disable-next-line */}
      <a href="#" className={"scrolltop"} id="scrolling-top">
        <FaArrowUp />
      </a>
    </div>
  );
}

export default App;
